Shopify.AjaxCart = {

  settings: {

    // cartTotalPrice: ,

    shippingPrice: 0,
    freeShippingThreshold: 0

  },

  translations: {
    "title": "Shopping Cart",
    "cart": {
      "empty_cart": "Your Cart is Empty",
      "loading": "Loading"
    },
    "shipping_banner": {
      "text_required_html": "Spend SHIPPING_PRICE more to get free shipping",
      "text_free_html": "Congrats! You qualify for free shipping."
    },
    "cart_notes": {
      "title": "Order Notes",
      "view_terms": "View terms",
      "agree_to_terms": "I agree with the terms and conditions."
    },
    "statement": {
      "label_shipping": "Shipping",
      "label_savings": "Savings",
      "label_subtotal": "Subtotal",
      "label_total": "Total"
    },
    "buttons": {
      "cart": "Go to Cart",
      "checkout": "Check Out"
    }
  },

  storage: {

    cart: null

  },

  api: {

    addItem: function(options){

      var settings = $.extend({}, options);

      var quantity = settings.quantity;
      var id = settings.id;

      var data = {
        quantity: quantity,
        id: id
      };

      $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: data,
        beforeSend: function(){

          Shopify.AjaxCart.functions.cartOverlayShow();

          $("#ajax-cart").trigger("ajax-cart.add-item.before");

          if (typeof settings.beforeSend === 'function') {
            settings.beforeSend();
          }

        },
        error: function(){

          Shopify.AjaxCart.functions.cartOverlayHide();

          $("#ajax-cart").trigger("ajax-cart.add-item.error");

          if (typeof settings.error === 'function') {
            settings.error();
          }

        },
        success: function (data) {

          Shopify.AjaxCart.api.updateCart();

          $("#ajax-cart").trigger("ajax-cart.add-item.success");

          if (typeof settings.success === 'function') {
            settings.success();
          }

        }
      });

    },

    changeItemQuantity: function(options){

      var settings = $.extend({}, options)

      var quantity = settings.quantity;
      var id = settings.id;

      var data = {
        quantity: quantity,
        id: id
      };

      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        error: function(){

          $("#ajax-cart").trigger("ajax-cart.change-item.error", [data]);

          if (typeof settings.error === 'function') {
            settings.error();
          }

        },
        beforeSend: function(){

          Shopify.AjaxCart.functions.cartOverlayShow();

          $("#ajax-cart").trigger("ajax-cart.change-item.before", [data]);

          if (typeof settings.beforeSend === 'function') {
            settings.beforeSend();
          }

        },
        success: function (data) {

          Shopify.AjaxCart.api.updateCart();

          $("#ajax-cart").trigger("ajax-cart.change-item.success", [data]);

          if (typeof settings.success === 'function') {
            settings.success();
          }

        }
      });

    },

    clear: function(options) {
      var settings = $.extend({}, options);

      $.ajax({
        url: '/cart/clear.js',
        cache: false,
        error: function(){

          $("#ajax-cart").trigger("ajax-cart.update-cart.error");

          if (typeof settings.error === 'function') {
            settings.error();
          }

        },
        complete: function(){
          Shopify.AjaxCart.api.updateCart();
          if (typeof settings.complete === 'function') {
            settings.complete();
          }

        }
      });
    },

    updateCart: function(options){

      var settings = $.extend({}, options)

      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        error: function(){

          $("#ajax-cart").trigger("ajax-cart.update-cart.error");

          if (typeof settings.error === 'function') {
            settings.error();
          }

        },
        beforeSend: function(){

          Shopify.AjaxCart.functions.cartOverlayShow();

          $("#ajax-cart").trigger("ajax-cart.update-cart.before");

          if (typeof settings.beforeSend === 'function') {
            settings.beforeSend();
          }

        },
        complete: function(){

          Shopify.AjaxCart.functions.cartOverlayHide();

          if (typeof settings.complete === 'function') {
            settings.complete();
          }

        },
        success: function(data){

          Shopify.AjaxCart.storage.cart = data;
          Shopify.AjaxCart.functions.refreshShipping();
          Shopify.AjaxCart.functions.refreshCart();
          Shopify.AjaxCart.functions.refreshTotals();

          $("#ajax-cart").trigger("ajax-cart.update-cart.success", [data]);

          if (typeof settings.success === 'function') {
            settings.success(data);
          }

        }
      });

    }

  },

  templates: {

    cartItem: function(data){

      var id = data.id;
      var image = data.image;
      var title = data.product_title;
      var price = data.price;
      var price_formatted = Shopify.formatMoney(price, $('body').data('money-format'));
      var quantity = data.quantity;
      var url = data.url;
      var variants = data.variant_options;

      var html = "";

      html +=  '<div class="ajax-cart-item" data-id="' + id + '">';
      html +=    '<div class="ajax-cart-item__image">';

      if (image) {
      html +=        '<a href="' + url + '">';
      html +=          '<img src="' + image + '" alt="' + title + '"/>';
      html +=        '</a>';
      }

      html +=    '</div>';

      html +=    '<div class="ajax-cart-item__properties">';
      html +=      '<a class="ajax-cart-item__link" href="' + url + '">';
      html +=        '<div class="ajax-cart-item__title">' + title + '</div>';
      html +=      '</a>';
      html +=      '<div class="ajax-cart-item__variants">';

      if (variants[0] !== "Default Title") {
        for (var i = 0; i < variants.length; i++) {
          html += variants[i] + '<br>';
        }
      }

      /*
      html +=          '';
      html +=            '';
      html +=          '';
      html +=          '';
      */
      html +=      '</div>';
      html +=      '<div class="ajax-cart-quantity-selector">';
      html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__decrement">-</span>';
      html +=        '<input class="ajax-cart-quantity-selector__quantity" type="number" min="0" size="2" name="updates[]" id="updates_' + id + '" value="' + quantity + '" data-line-id=""/>';
      html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__increment">+</span>';
      html +=      '</div>';
      html +=      '<strong class="ajax-cart-item__price">';

      if (price) {
      html +=        '';
      }

      html +=        '<span class="money">' + price_formatted + '</span>';
      html +=      '</strong>';
      html +=      '<span tabindex="0" class="ajax-cart-item__remove">Remove</span>';
      html +=    '</div>';
      html +=  '</div>';

      return html;

    },

    cartEmptyMessage: function(){

      var html = "";

      html += '<div class="ajax-cart-empty-message">';
      html +=   '<p>' + Shopify.AjaxCart.translations.cart.empty_cart + '</p>';
      html += '</div>';

      return html;

    },

    cartContentsOverlay: function(options){

      var text = Shopify.AjaxCart.translations.cart.loading;

      if (typeof options != "undefined") {
        if (typeof options.text === "string") {
          text = options.text;
        }
      }

      var html = "";

      html +=  '<div class="ajax-cart-contents-overlay">';
      html +=    '<div class="ajax-cart-contents-overlay__content">';
      html +=      '<div class="ajax-cart-contents-overlay__icon animation--pulse"><img src="//cdn.shopify.com/s/files/1/0032/2027/5246/files/archrednobaseRED.png?17862" alt="" /></div>';
      // html +=      '<div class="ajax-cart-contents-overlay__text">Loading...</div>';
      html +=    '</div>';
      html +=  '</div>';

      return html;

    },

  },

  functions: {

    cartToggle: function(e){

      var open = $('.ajax-cart').hasClass('ajax-cart--opened') === true;

      if (open === true) {
        Shopify.AjaxCart.eventHandlers.cartClose();
      }
      else {
        Shopify.AjaxCart.eventHandlers.cartOpen();
      }

    },

    cartOpen: function(e){

      $(".ajax-cart")
        .addClass('ajax-cart--opened')
        .removeClass('ajax-cart--closed');

      $(".ajax-cart-overlay").fadeIn();

      $("#ajax-cart").trigger("ajax-cart.cart-open");

      $("body").addClass("ajax-cart--lock-scroll");

    },

    cartClose: function(){

      $(".ajax-cart")
        .removeClass('ajax-cart--opened')
        .addClass('ajax-cart--closed');

      $(".ajax-cart-overlay").fadeOut();

      $("#ajax-cart").trigger("ajax-cart.cart-close");

      $("body").removeClass("ajax-cart--lock-scroll");

    },

    cartOverlayShow: function(){

      if ( $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay').length > 0 ) {
        return;
      }

      var overlay = Shopify.AjaxCart.templates.cartContentsOverlay({ text: "Cart Loading..." });
      var container = $('.ajax-cart .ajax-cart__body');

      overlay = $(overlay)[0];

      container.prepend(overlay);

    },

    cartOverlayHide: function(){

      var overlay = $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay');

      $(overlay).remove();

    },

    refreshShipping: function(){

      var freeShipping = Shopify.AjaxCart.storage.cart.total_price >= Shopify.AjaxCart.settings.freeShippingThreshold ? true : false;
      var shippingBannerText;

      if (freeShipping === true) {

        $('.ajax-cart-banner').addClass('ajax-cart-banner--success');

        shippingBannerText = Shopify.AjaxCart.translations.shipping_banner.text_free_html;

      }
      else {

        $('.ajax-cart-banner').removeClass('ajax-cart-banner--success');

        var moneyFormat = $('body').data('money-format');

        var shippingPriceDifference = Shopify.AjaxCart.settings.freeShippingThreshold - Shopify.AjaxCart.storage.cart.total_price;
        var shippingPriceDifferenceDisplay = Shopify.formatMoney(shippingPriceDifference, moneyFormat);

        shippingBannerText = Shopify.AjaxCart.translations.shipping_banner.text_required_html;
        shippingBannerText = shippingBannerText.replace("SHIPPING_PRICE", shippingPriceDifferenceDisplay)

      }

      $('.ajax-cart-banner__text').html(shippingBannerText);

    },

    refreshCart: function(){

      var cartCount = Shopify.AjaxCart.storage.cart.item_count;
      var cartItems = Shopify.AjaxCart.storage.cart.items;
      var cartContainer = $('.ajax-cart__items');

      if (cartItems.length > 0) {
        showCartItems();
      }
      else {
        showEmptyMessage();
      }

      $('[data-ajaxcart-value]').text(cartCount);

      function showEmptyMessage() {

        var html = Shopify.AjaxCart.templates.cartEmptyMessage();

        cartContainer.html(html);

      }

      function showCartItems() {

        var html = "";

        for (var i = 0; i < cartItems.length; i++) {
          html += Shopify.AjaxCart.templates.cartItem(cartItems[i]);
        }

        cartContainer.html(html);

      }

    },

    refreshTotals: function(){

      var moneyFormat = $('body').data('money-format');
      var shippingIsFree = Shopify.AjaxCart.storage.cart.total_price >= Shopify.AjaxCart.settings.freeShippingThreshold ? true : false;

      var lineShipping = $('.ajax-cart-statement-line--shipping .ajax-cart-statement-line__value');
      var lineSavings = $('.ajax-cart-statement-line--savings .ajax-cart-statement-line__value');
      var lineSubtotal = $('.ajax-cart-statement-line--subtotal .ajax-cart-statement-line__value');
      var lineTotal = $('.ajax-cart-statement-line--total .ajax-cart-statement-line__value');

      var valueShipping = shippingIsFree === true ? 0: Shopify.AjaxCart.settings.shippingPrice;
      var valueSavings = Shopify.AjaxCart.storage.cart.total_discount;
      var valueSubtotal = Shopify.AjaxCart.storage.cart.total_price;
      var valueTotal = valueSubtotal - valueSavings + valueShipping;

      var displayShipping = shippingIsFree === true ? '<span class="free_shipping">Free</span>': Shopify.formatMoney(Shopify.AjaxCart.settings.shippingPrice, moneyFormat);
      var displaySavings = Shopify.formatMoney(valueSavings, moneyFormat);
      var displaySubtotal = Shopify.formatMoney(valueSubtotal, moneyFormat);
      var displayTotal = Shopify.formatMoney(valueTotal, moneyFormat);

      lineShipping.html(displayShipping);
      lineSavings.html(displaySavings);
      lineSubtotal.html(displaySubtotal);
      lineTotal.html(displayTotal);

    },

    addEventListeners: function() {

      $('.ajax-cart__items').on("click", '.ajax-cart-item__remove', Shopify.AjaxCart.eventHandlers.itemRemove);
      $('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__increment', Shopify.AjaxCart.eventHandlers.onClickItemIncrement);
      $('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__decrement', Shopify.AjaxCart.eventHandlers.onClickItemDecrement);
      $('.ajax-cart__items').on("change", '.ajax-cart-quantity-selector__quantity', Shopify.AjaxCart.eventHandlers.onChangeItemQuantity);

      $('body').on("click", ".ajax-cart-overlay", Shopify.AjaxCart.eventHandlers.onClickCartClose);

      $('body').on('click', '.ajax-cart--trigger-open', Shopify.AjaxCart.eventHandlers.onClickCartOpen);
      $('body').on('click', '.ajax-cart--trigger-close', Shopify.AjaxCart.eventHandlers.onClickCartClose);
      $('body').on('click', '.ajax-cart--trigger-toggle', Shopify.AjaxCart.eventHandlers.onClickCartToggle);
      $('body').on("click", '.ajax-cart--trigger-submit', Shopify.AjaxCart.eventHandlers.onClickCheckout);
      $('body').on("click", '.ajax-cart--trigger-gotocart', Shopify.AjaxCart.eventHandlers.onClickGoToCart);
      $('body').on("click", '.ajax-cart--trigger-add-upsell', Shopify.AjaxCart.eventHandlers.onClickAddUpsell);
      $('body').on('click', '.action_button--clear-cart', Shopify.AjaxCart.eventHandlers.clearCart);
    }

  },

  eventHandlers: {

    onClickGoToCart: function(){
      location.href = '/cart';
    },

    onClickCheckout: function(e){

      e.preventDefault();

      $('.ajax-cart__form').submit();

    },

    onClickCartOpen: function(e){

      e.preventDefault();
      Shopify.AjaxCart.functions.cartOpen();

    },

    onClickCartClose: function(e){

      e.preventDefault();
      Shopify.AjaxCart.functions.cartClose();

    },

    onClickCartToggle: function(e){

      e.preventDefault();
      Shopify.AjaxCart.functions.cartToggle();

    },

    onClickAddUpsell: function(e){

      var button = $(e.currentTarget);
      var upsell = button.closest(".ajax-cart-upsell");
      var id = upsell.data("id");

      var options = {
        id: id,
        quantity: 1,
      };

      Shopify.AjaxCart.api.addItem(options);

    },

    onClickItemIncrement: function(e){

      var button = $(e.currentTarget);
      var selector = button.closest('.ajax-cart-quantity-selector');
      var input = selector.find('.ajax-cart-quantity-selector__quantity');
      var value = input.val();

      value++;
      input.val(value);

      input.trigger("change");

    },

    onClickItemDecrement: function(e){

      var button = $(e.currentTarget);
      var selector = button.closest('.ajax-cart-quantity-selector');
      var input = selector.find('.ajax-cart-quantity-selector__quantity');
      var value = input.val();

      value--;
      input.val(value);

      input.trigger("change");

    },

    onChangeItemQuantity: function(e){

      var input = $(e.currentTarget);
      var item = input.closest(".ajax-cart-item");
      var id = item.data("id");
      var quantity = input.val();

      Shopify.AjaxCart.api.changeItemQuantity({
        id: id,
        quantity: quantity
      });

    },

    itemRemove: function(e){

      var input = $(e.currentTarget);
      var item = input.closest(".ajax-cart-item");
      var id = item.data("id");
      var quantity = input.val();

      Shopify.AjaxCart.api.changeItemQuantity({
        id: id,
        quantity: 0
      });

    },

    clearCart: function(e) {
      e.preventDefault();
      Shopify.AjaxCart.api.clear();
      window.location.href = "/pages/wholesale-ordering";
    }

  },

  init: function(){

    Shopify.AjaxCart.functions.addEventListeners();
    Shopify.AjaxCart.api.updateCart();

  }

};

Shopify.AjaxCart.init();
